module.exports = __webpack_public_path__ + "static/img/section03-02@m.daea7a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/siliconwork-renewal/section03-02@m.jpg
// module id = A9ai
// module chunks = 0